import { render, staticRenderFns } from "./TabProducts.vue?vue&type=template&id=233dfaaa&scoped=true&"
import script from "./TabProducts.vue?vue&type=script&lang=js&"
export * from "./TabProducts.vue?vue&type=script&lang=js&"
import style0 from "./TabProducts.vue?vue&type=style&index=0&id=233dfaaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233dfaaa",
  null
  
)

export default component.exports